import isPlainObject from 'lodash/isPlainObject';
import {
  UseFormGetValues,
  UseFormSetValue,
} from 'react-hook-form';
import {
  AnvilForm,
} from 'components/anvilFormFillable/fields/types';
import {
  getFormFieldKey,
} from 'utils/formFieldKey';
import {
  isEmptyString,
} from 'utils/helper';

type SignatureFormFieldsData = {
  signature?: string;
  signatureDraw?: string;
  signatureTyped?: string;
  initial?: string;
  initialDraw?: string;
  initialTyped?: string;
  consent?: boolean;
  startSigning?: boolean;
} & Record<string, unknown>;

export function getFieldStateKey(field: Pick<AnvilForm, 'formId' | 'id'>): string {
  return getFormFieldKey(field.formId ?? 0, field.id ?? '');
}

function getGlobalFieldValue(
  fieldType: string,
  signature: string,
  initial: string,
): string | null {
  if (fieldType === 'signature') {
    return signature;
  }
  if (fieldType === 'initial') {
    return initial;
  }
  return null;
}

export function applyGlobalSignatureToFields<TFieldValues extends SignatureFormFieldsData>(
  fields: AnvilForm[],
  signature: string,
  initial: string,
  setValue: UseFormSetValue<TFieldValues>,
  getValues: UseFormGetValues<TFieldValues>,
): void {
  fields.forEach((field) => {
    const globalValue = getGlobalFieldValue(field.type, signature, initial);

    if (globalValue === null || isEmptyString(globalValue)) {
      return;
    }

    const fieldStateKey = getFieldStateKey(field);
    const previous = getValues(fieldStateKey as never);
    const fieldValue = isPlainObject(previous)
      ? { ...field, ...(previous as Partial<AnvilForm>) }
      : field;

    setValue(
      fieldStateKey as never,
      { ...fieldValue, value: globalValue } as never,
      { shouldValidate: false },
    );
  });
}

export function getPreservedGlobalPrepValues(
  current: SignatureFormFieldsData,
): Pick<
SignatureFormFieldsData,
'signature' | 'signatureDraw' | 'signatureTyped' | 'initial' | 'initialDraw' | 'initialTyped' | 'consent' | 'startSigning'
> {
  return {
    signature: current.signature ?? '',
    signatureDraw: current.signatureDraw ?? '',
    signatureTyped: current.signatureTyped ?? '',
    initial: current.initial ?? '',
    initialDraw: current.initialDraw ?? '',
    initialTyped: current.initialTyped ?? '',
    consent: current.consent,
    startSigning: current.startSigning,
  };
}
